import { dentalIcons } from "./utils-icons/dentalIcons";

const projectStatsDummyData = [
  {
    id: "1",
    title: "Total Projects",
    count: 25,
    icon: dentalIcons?.totalProjectsIcon,
    bgColor: "#E3EBFF",
  },
  {
    id: "2",
    title: "Active Projects",
    count: 25,
    icon: dentalIcons?.activeProjectsIcon,
    bgColor: "#DEF5DB",
  },
  {
    id: "3",
    title: "Completed Projects",
    count: 25,
    icon: dentalIcons?.completedProjectIcon,
    bgColor: "#D2F3FA",
  },
  {
    id: "4",
    title: "Collaborated Projects",
    count: 25,
    icon: dentalIcons?.colaboratedProjectsIcon,
    bgColor: "#FFEBD4",
  },
];
export default projectStatsDummyData;

export const dummyCollaborators = [
  {
    id: 1,
    title: "Dr.Salem",
    email: "salem@gmail.com",
  },
  {
    id: 2,
    title: "Dr.Arif",
    email: "arif@gmail.com",
  },
  {
    id: 3,
    title: "Dr.Mark",
    email: "Mark@gmail.com",
  },
  {
    id: 4,
    title: "Dr.Jhon Do",
    email: "jhondo@gmail.com",
  },
  {
    id: 5,
    title: "Dr.Foo",
    email: "fooBar@gmail.com",
  },
];

export const dummyProjectsData = [
  {
    id: 1,
    pmCase: "PM - 001",
    bestMatch: "AM - 87900",
    highestScore: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 2,
    pmCase: "PM - 001",
    bestMatch: "AM - 87900",
    highestScore: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 3,
    pmCase: "PM - 001",
    bestMatch: "AM - 87900",
    highestScore: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 4,
    pmCase: "PM - 001",
    bestMatch: "AM - 87900",
    highestScore: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 5,
    pmCase: "PM - 001",
    bestMatch: "AM - 87900",
    highestScore: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 6,
    pmCase: "PM - 001",
    bestMatch: "AM - 87900",
    highestScore: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
];
export const dummyProjects = [
  {
    id: 1,
    title: "Porject Title",
    projectId: "001",
    date: "23-12-2024",
    createdBy: "Dr. Salem",
    totalAm: "100",
    pendingAm: "30",
    totalPm: "100",
    pendingPm: "50",
    status: "open",
  },
  {
    id: 2,
    title: "Porject Title",
    projectId: "001",
    date: "23-12-2024",
    createdBy: "Dr. Salem",
    totalAm: "100",
    pendingAm: "30",
    totalPm: "100",
    pendingPm: "50",
    status: "closed",
  },
  {
    id: 3,
    title: "Porject Title",
    projectId: "001",
    date: "23-12-2024",
    createdBy: "Dr. Salem",
    totalAm: "100",
    pendingAm: "30",
    totalPm: "100",
    pendingPm: "50",
    status: "archive",
  },
  {
    id: 4,
    title: "Porject Title",
    projectId: "001",
    date: "23-12-2024",
    createdBy: "Dr. Salem",
    totalAm: "100",
    pendingAm: "30",
    totalPm: "100",
    pendingPm: "50",
    status: "open",
  },
  {
    id: 5,
    title: "Porject Title",
    projectId: "001",
    date: "23-12-2024",
    createdBy: "Dr. Salem",
    totalAm: "100",
    pendingAm: "30",
    totalPm: "100",
    pendingPm: "50",
    status: "open",
  },
];
export const dummyCollaboratorsData = [
  {
    id: 1,
    title: "Dr. Alison Ogaga",
    email: "Alison@gmail.com",
    amCaseAdded: "24",
    pmCaseAdded: "40",
    amDentalRecordAdded: "100",
    pmDentalRecordAdded: "10",
  },
  {
    id: 2,
    title: "Dr. Alison Ogaga",
    email: "Alison@gmail.com",
    amCaseAdded: "24",
    pmCaseAdded: "40",
    amDentalRecordAdded: "100",
    pmDentalRecordAdded: "10",
  },
];
export const dummyAmPmCasesRecordData = [
  {
    id: 1,
    caseNo: 87900,
    caseType: "AM",
    subjectName: "Abdullah",
    gender: "Male",
    addedBy: "Dr. Salem",
    missingDate: "28-11-2024",
    recordAdded: "added",
  },
  {
    id: 2,
    caseNo: 87900,
    caseType: "PM",
    subjectName: "Abdullah",
    gender: "Male",
    addedBy: "Dr. Salem",
    missingDate: "28-11-2024",
    recordAdded: "missing",
  },
  {
    id: 3,
    caseNo: 87900,
    caseType: "PM",
    subjectName: "Abdullah",
    gender: "Male",
    addedBy: "Dr. Salem",
    missingDate: "28-11-2024",
    recordAdded: "added",
  },
  {
    id: 4,
    caseNo: 87900,
    caseType: "PM",
    subjectName: "Abdullah",
    gender: "Male",
    addedBy: "Dr. Salem",
    missingDate: "28-11-2024",
    recordAdded: "added",
  },
  {
    id: 5,
    caseNo: 87900,
    caseType: "PM",
    subjectName: "Abdullah",
    gender: "Male",
    addedBy: "Dr. Salem",
    missingDate: "28-11-2024",
    recordAdded: "added",
  },
  {
    id: 6,
    caseNo: 87900,
    caseType: "PM",
    subjectName: "Abdullah",
    gender: "Male",
    addedBy: "Dr. Salem",
    missingDate: "28-11-2024",
    recordAdded: "missing",
  },
];

export const dummyCollaboratorRecordAddedData = [
  {
    id: 1,
    name: "Dr. Khan",
    amAdded: "26",
    pmAdded: "26",
    amDentalAdded: "26",
    pmDentalAdded: "26",
    date: "02-11-2024",
  },
  {
    id: 2,
    name: "Dr. Khan",
    amAdded: "26",
    pmAdded: "26",
    amDentalAdded: "26",
    pmDentalAdded: "26",
    date: "02-11-2024",
  },
  {
    id: 3,
    name: "Dr. Khan",
    amAdded: "26",
    pmAdded: "26",
    amDentalAdded: "26",
    pmDentalAdded: "26",
    date: "02-11-2024",
  },
  {
    id: 4,
    name: "Dr. Khan",
    amAdded: "26",
    pmAdded: "26",
    amDentalAdded: "26",
    pmDentalAdded: "26",
    date: "02-11-2024",
  },
  {
    id: 5,
    name: "Dr. Khan",
    amAdded: "26",
    pmAdded: "26",
    amDentalAdded: "26",
    pmDentalAdded: "26",
    date: "02-11-2024",
  },
  {
    id: 6,
    name: "Dr. Khan",
    amAdded: "26",
    pmAdded: "26",
    amDentalAdded: "26",
    pmDentalAdded: "26",
    date: "02-11-2024",
  },
];

export const mapedProjectStatus = (status) => {
  let textColor = "";
  let bgColor = "";
  if (status === "open") {
    bgColor += "#50F5AE78";
    textColor += "#00B366";
  } else if (status === "archive") {
    bgColor += "#FFFBDE";
    textColor += "#E8AD00";
  } else if (status === "closed") {
    bgColor += "#FFD0D0";
    textColor += "#DC1919";
  }
  return {
    textColor,
    bgColor,
  };
};

export const mapMatchStatus = (status) => {
  let textColor = "";
  let bgColor = "";
  let statusText = "N/A";

  if (status === "match") {
    statusText = "Match";
    bgColor += "#F4FFF5";
    textColor += "#15BC3A";
  } else if (status === "mismatch") {
    statusText = "Mismatch";
    bgColor += "#FFF2F5";
    textColor += "#DC1919";
  } else if (status === "possible_match") {
    statusText = "Possible Match";
    bgColor += "#FFFBDE";
    textColor += "#EF7D02";
  } else if (status === "unknown") {
    bgColor += "#FFFBDE";
    textColor += "#EF7D02";
    statusText = "Not Comparable";
  }
  return {
    textColor,
    bgColor,
    statusText,
  };
};
export const mapedProjectQuadrantStatus = (status) => {
  let textColor = "";
  let bgColor = "";

  if (status === "match") {
    bgColor += "#F4FFF5";
    textColor += "#15BC3A";
  } else if (status === "mismatch") {
    bgColor += "#FFF2F5";
    textColor += "#DC1919";
  } else if (status === "possible_match") {
    bgColor += "#FFFBDE";
    textColor += "#EF7D02";
  } else if (status === "unknown") {
    bgColor += "#FFFBDE";
    textColor += "#EF7D02";
  }
  return {
    textColor,
    bgColor,
  };
};

export const dentalRecordData = [
  {
    id: 1,
    data: [
      {
        id: 1,
        toothNumber: 18,
        icon: dentalIcons.fq18,
      },
      {
        id: 2,
        toothNumber: 17,
        icon: dentalIcons.fq17,
      },
      {
        id: 3,
        toothNumber: 16,
        icon: dentalIcons.fq16,
      },
      {
        id: 4,
        toothNumber: 15,
        icon: dentalIcons.fq15,
      },
      {
        id: 5,
        toothNumber: 14,
        icon: dentalIcons.fq14,
      },
      {
        id: 6,
        toothNumber: 13,
        icon: dentalIcons.fq13,
      },
      {
        id: 7,
        toothNumber: 12,
        icon: dentalIcons.fq12,
      },
      {
        id: 8,
        toothNumber: 11,
        icon: dentalIcons.fq11,
      },
    ],
  },
  {
    id: 2,
    data: [
      {
        id: 32,
        toothNumber: 48,
        icon: dentalIcons.fq48,
      },
      {
        id: 31,
        toothNumber: 47,
        icon: dentalIcons.fq47,
      },
      {
        id: 30,
        toothNumber: 46,
        icon: dentalIcons.fq46,
      },
      {
        id: 29,
        toothNumber: 45,
        icon: dentalIcons.fq45,
      },
      {
        id: 28,
        toothNumber: 44,
        icon: dentalIcons.fq44,
      },
      {
        id: 27,
        toothNumber: 43,
        icon: dentalIcons.fq43,
      },
      {
        id: 26,
        toothNumber: 42,
        icon: dentalIcons.fq42,
      },
      {
        id: 25,
        toothNumber: 41,
        icon: dentalIcons.fq41,
      },
    ],
  },
  {
    id: 3,
    data: [
      {
        id: 9,
        toothNumber: 21,
        icon: dentalIcons.fq21,
      },
      {
        id: 10,
        toothNumber: 22,
        icon: dentalIcons.fq22,
      },
      {
        id: 11,
        toothNumber: 23,
        icon: dentalIcons.fq23,
      },
      {
        id: 12,
        toothNumber: 24,
        icon: dentalIcons.fq24,
      },
      {
        id: 13,
        toothNumber: 25,
        icon: dentalIcons.fq25,
      },
      {
        id: 14,
        toothNumber: 26,
        icon: dentalIcons.fq26,
      },
      {
        id: 15,
        toothNumber: 27,
        icon: dentalIcons.fq27,
      },
      {
        id: 16,
        toothNumber: 28,
        icon: dentalIcons.fq28,
      },
    ],
  },
  {
    id: 4,
    data: [
      {
        id: 24,
        toothNumber: 31,
        icon: dentalIcons.fq31,
      },
      {
        id: 23,
        toothNumber: 32,
        icon: dentalIcons.fq32,
      },
      {
        id: 22,
        toothNumber: 33,
        icon: dentalIcons.fq33,
      },
      {
        id: 21,
        toothNumber: 34,
        icon: dentalIcons.fq34,
      },
      {
        id: 20,
        toothNumber: 35,
        icon: dentalIcons.fq35,
      },
      {
        id: 19,
        toothNumber: 36,
        icon: dentalIcons.fq36,
      },
      {
        id: 18,
        toothNumber: 37,
        icon: dentalIcons.fq37,
      },
      {
        id: 17,
        toothNumber: 38,
        icon: dentalIcons.fq38,
      },
    ],
  },
];

export const dentalRecordTypeData = [
  {
    id: 1,
    color: "#DA6A6D",
    data: [
      {
        id: 11,
        type: "M-T",
        icon: dentalIcons.missingM1,
        title: "Missing - Implant",
      },
      {
        id: 12,
        type: "M-B",
        icon: dentalIcons.missingMB,
        title: "Missing - Bridge",
      },
      {
        id: 13,
        type: "M-A",
        icon: dentalIcons.missingMA,
        title: "Missing - Antemortem",
      },
      {
        id: 14,
        type: "M-P",
        icon: dentalIcons.missingMP,
        title: "Missing - Postmortem",
      },
    ],
  },
  {
    id: 2,
    color: "#49B2DE",
    data: [
      {
        id: 21,
        type: "R-C",
        icon: dentalIcons.restoredRC,
        title: "Restored - Crown",
      },
      {
        id: 22,
        type: "R-P",
        icon: dentalIcons.restoredRP,
        title: "Restored - Prostheses",
      },
      {
        id: 23,
        type: "R-R",
        icon: dentalIcons.restoredRR,
        title: "Restored - Root",
      },
      {
        id: 24,
        type: "R-A",
        icon: dentalIcons.restoredRA,
        title: "Restored - Appliance",
      },
    ],
  },
  {
    id: 3,
    color: "#E29365",
    data: [
      {
        id: 31,
        type: "P-M",
        icon: dentalIcons.presentPM,
        title: "Present - Morphology",
      },
      {
        id: 32,
        type: "P-V",
        icon: dentalIcons.presentPV,
        title: "Present - Variation",
      },
      {
        id: 33,
        type: "P-P",
        icon: dentalIcons.presentPP,
        title: "Present - Pathology",
      },
      {
        id: 34,
        type: "P-S",
        icon: dentalIcons.presentPS,
        title: "Present - Sound",
      },
    ],
  },
  {
    id: 4,
    color: "#9765B6",
    data: [
      {
        id: 41,
        type: "L-B",
        icon: dentalIcons.landmarkLB,
        title: "Landmark - Bone",
      },
      {
        id: 42,
        type: "L-O",
        icon: dentalIcons.landmarkLO,
        title: "Landmark - Occlusal",
      },
      {
        id: 43,
        type: "L-M",
        icon: dentalIcons.landmarkLM,
        title: "Landmark - Modifications",
      },
      {
        id: 44,
        type: "L-C",
        icon: dentalIcons.landmarkLC,
        title: "Landmark - Cysts",
      },
    ],
  },
];

export const detailForDentalTypeData = [
  {
    id: 1,
    title: "Implant",
  },
  {
    id: 2,
    title: "Abutment Implant",
  },
  {
    id: 3,
    title: "Bridge Implant",
  },
  {
    id: 4,
    title: "Mini Implant",
  },
  {
    id: 5,
    title: "Bone-Level Implant",
  },
  {
    id: 6,
    title: "Tissue-Level Implant",
  },
  {
    id: 7,
    title: "Orthodontic Implant",
  },
  {
    id: 8,
    title: "Full-Arch Prosthesis with 4 Implants",
  },
  {
    id: 9,
    title: "Full-Arch Prosthesis with 6 Implants",
  },
];

export const dummySingleCaseResultsData = [
  {
    id: 1,
    iso: "13",
    toothName: "Upper Right Canine",
    amDetail: "Bridge Implant",
    pmDetail: "Bridge Implant",
    matchStatus: "Match",
    status: "match",
  },
  {
    id: 2,
    iso: "35",
    toothName: "Lower Left 2nd Premolar",
    amDetail: "Metal Inlay , Class 1-0",
    pmDetail: "Metal Inlay , Class 1-0",
    matchStatus: "Match",
    status: "match",
  },
  {
    id: 3,
    iso: "35",
    toothName: "Lower Left 2nd Premolar",
    amDetail: "EXtracted Tooth",
    pmDetail: "Completely Denture",
    matchStatus: "MisMatch",
    status: "mismatch",
  },
  {
    id: 4,
    iso: "35",
    toothName: "Lower Left 2nd Premolar",
    amDetail: "Gold Crown",
    pmDetail: "Metal Crown",
    matchStatus: "Possible Match",
    status: "possiblematch",
  },
  {
    id: 5,
    iso: "35",
    toothName: "Lower Left 2nd Premolar",
    amDetail: "Gold Crown",
    pmDetail: "Metal Crown",
    matchStatus: "Mis Match",
    status: "mismatch",
  },
  {
    id: 6,
    iso: "35",
    toothName: "Lower Left 2nd Premolar",
    amDetail: "Gold Crown",
    pmDetail: "Metal Crown",
    matchStatus: "Possible Match",
    status: "possiblematch",
  },
  {
    id: 7,
    iso: "35",
    toothName: "Lower Left 2nd Premolar",
    amDetail: "Gold Crown",
    pmDetail: "Metal Crown",
    matchStatus: "Match",
    status: "match",
  },
];

export const dummyCaseAllRecordsData = [
  {
    id: 1,
    pmCase: "PM - 001",
    amCase: "Am-123",
    score: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 2,
    pmCase: "PM - 001",
    amCase: "Am-123",
    score: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 3,
    pmCase: "PM - 001",
    amCase: "Am-123",
    score: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 4,
    pmCase: "PM - 001",
    amCase: "Am-123",
    score: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 5,
    pmCase: "PM - 001",
    amCase: "Am-123",
    score: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 6,
    pmCase: "PM - 001",
    amCase: "Am-123",
    score: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 6,
    pmCase: "PM - 001",
    amCase: "Am-123",
    score: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 6,
    pmCase: "PM - 001",
    amCase: "Am-123",
    score: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 6,
    pmCase: "PM - 001",
    amCase: "Am-123",
    score: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
  {
    id: 6,
    pmCase: "PM - 001",
    amCase: "Am-123",
    score: "90",
    matchCount: "24",
    possibleMatches: 3,
    mismatchCount: 5,
  },
];

export const dummyQuadraantDetails = [
  {
    id: "1",
    quadrant: "Upper Right Quadrant (UR - Q1)",
    amDetail: "Bridge Implant",
    pmDetail: "Bridge Implant",
    status: "hit",
  },
  {
    id: "2",
    quadrant: "Upper Left Quadrant (UL - Q2)",
    amDetail: "Metal Inlay , Class 1-0",
    pmDetail: "Metal Inlay , Class 1-0",
    status: "hit",
  },
  {
    id: "3",
    quadrant: "Lower Left Quadrant (LL - Q3)",
    amDetail: "Extracted Tooth",
    pmDetail: "Completely Denture",
    status: "miss",
  },
  {
    id: "4",
    quadrant: "Lower Right Quadrant (LR - Q4)",
    amDetail: "Gold Crown",
    pmDetail: "Metal Crown",
    status: "possible",
  },
];

export const dummyObservation = [
  {
    title: "Upper Molar 1",
    value: "ISO. 17",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
  {
    title: "Upper Molar 10",
    value: "ISO. 18",
    observation:
      "The tooth is damaged completely , can't restore it's original position",
  },
];

export const dummyRecentProjectsData = [
  {
    id: 96969,
    title: "Project Alpha",
    totalCases: "120",
    date: "01-Oct-2024",
    lastUpdate: "09-Oct-2024",
    collaborated: "yes",
    status: "completed",
  },
  {
    id: 96969,
    title: "Project Alpha",
    totalCases: "120",
    date: "01-Oct-2024",
    lastUpdate: "09-Oct-2024",
    collaborated: "yes",
    status: "completed",
  },
  {
    id: 96969,
    title: "Project Alpha",
    totalCases: "120",
    date: "01-Oct-2024",
    lastUpdate: "09-Oct-2024",
    collaborated: "yes",
    status: "archived",
  },
  {
    id: 96969,
    title: "Project Alpha",
    totalCases: "120",
    date: "01-Oct-2024",
    lastUpdate: "09-Oct-2024",
    collaborated: "yes",
    status: "open",
  },
  {
    id: 96969,
    title: "Project Alpha",
    totalCases: "120",
    date: "01-Oct-2024",
    lastUpdate: "09-Oct-2024",
    collaborated: "yes",
    status: "closed",
  },
];
